module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar', {
    attrs: {
      "title": "邀请有礼"
    }
  }), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "btn-box"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handlerInvite
    }
  }, [_vm._v("分享资料邀请")])]), _vm._v(" "), _c('div', {
    staticClass: "result__box"
  }, [_c('div', {
    staticClass: "result__cover"
  }, [_c('p', {
    staticClass: "money__box"
  }, [_c('span', {
    staticClass: "money__icon"
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm._f("currencyNormal")(_vm.dataObj.amount)))])]), _vm._v(" "), _c('p', [_vm._v("已获得奖金")])]), _vm._v(" "), _c('div', {
    staticClass: "result__title g-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/invite/title-left.png"),
      "alt": ""
    }
  }), _vm._v("\n            我的邀请记录\n            "), _c('img', {
    attrs: {
      "src": require("../../assets/images/invite/title-right.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list__box"
  }, [_c('ul', {
    staticClass: "list g-container"
  }, [_vm._l((_vm.dataObj.items), function(item, index) {
    return _c('li', {
      key: item + index,
      staticClass: "list__item"
    }, [_c('span', {
      staticClass: "list__span list__time"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("onlyDate")(item.rewardTime)))]), _vm._v(" "), _c('span', {
      staticClass: "time--only list__span list__tips"
    }, [_vm._v(_vm._s(_vm._f("onlyTime")(item.rewardTime)))])]), _vm._v(" "), _c('span', {
      staticClass: "list__span list__name"
    }, [_vm._v("\n                  " + _vm._s(item.rewardName) + "\n                   "), _c('span', {
      staticClass: "list__span list__tips"
    }, [_vm._v("\n                     " + _vm._s(_vm.computedStatus(item)) + "\n                   ")])]), _vm._v(" "), _c('span', {
      staticClass: "list__span list__money"
    }, [_c('span', {
      staticClass: "list__money__icon"
    }, [_vm._v("￥")]), _vm._v(_vm._s(item.amount) + "元")])])
  }), _vm._v(" "), (_vm.dataObj.items.length === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_c('p', [_vm._v("有奖不拿太可惜了")]), _vm._v(" "), _c('p', [_vm._v("快来邀请朋友参与吧")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "result__title g-container rule__box"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handlerProvision
    }
  }, [_c('img', {
    staticClass: "rule__leftimg",
    attrs: {
      "src": require("../../assets/images/invite-newversion/rule-left.png"),
      "alt": ""
    }
  }), _vm._v("\n            邀请规则\n            "), _c('img', {
    staticClass: "rule__rightimg",
    attrs: {
      "src": require("../../assets/images/invite-newversion/rule-right.png"),
      "alt": ""
    }
  })])])])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog__box"
  }, [_c('div', {
    staticClass: "dialog__title"
  }, [_c('h2', [_vm._v("请绑定您的微信")]), _vm._v(" "), _c('span', [_vm._v("用于公众号发送现金红包")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog__introduction"
  }, [_c('span', [_vm._v("\n            第一步：微信搜索【生意专家商户助手】公众号\n          ")]), _vm._v(" "), _c('span', [_vm._v("\n            第二步：点击【绑定账号】获得绑定验证码\n            ")]), _vm._v(" "), _c('span', [_vm._v("\n            第三步：回到本页面输入验证码\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog__main"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    ref: "J_Code",
    staticClass: "code__input",
    attrs: {
      "type": "text",
      "placeholder": "请输入【微信验证码】"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "blur": _vm.resetScroll,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "code__btn btn",
    on: {
      "click": _vm.wakewechat
    }
  }, [_vm._v("\n            打开微信\n             "), (_vm.bindLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "code__bind",
    class: {
      'weui-btn_loading': _vm.bindLoading
    },
    on: {
      "click": _vm.handlerBind
    }
  }, [_vm._v("完成绑定")])])])])])]), _vm._v(" "), _c('share', {
    attrs: {
      "visible": _vm.share.shareVisible,
      "config": _vm.share.config
    },
    on: {
      "update:visible": function($event) {
        _vm.share.shareVisible = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00d3cf9c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/invite/index.vue
// module id = 1008
// module chunks = 2